import { render, staticRenderFns } from "./MarketingCenterCanvasPreview.vue?vue&type=template&id=30857d46&scoped=true&"
import script from "./MarketingCenterCanvasPreview.vue?vue&type=script&lang=ts&"
export * from "./MarketingCenterCanvasPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingCenterCanvasPreview.vue?vue&type=style&index=0&id=30857d46&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30857d46",
  null
  
)

export default component.exports